import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { SkillRatingConstituents } from '~/monolith-api';

export type TeamSkillsCourse = {
   wikiid: number;
   title: string;
   average_skill_rating: number;
   constituents: SkillRatingConstituents;
};

export type GetCoursesInWhichATeamIsSkilledResponse = {
   courses: TeamSkillsCourse[];
   hasMore: boolean;
};

export type GetCoursesInWhichATeamIsSkilledOptions = CommonRequestOptions & {
   query?: string;
   order?: 'DESC' | 'ASC';
   offset?: number;
   limit?: number;
};

export function getCoursesInWhichATeamIsSkilled(
   teamid: number,
   { query, order, offset, limit, ...common }: GetCoursesInWhichATeamIsSkilledOptions = {}
): Promise<GetCoursesInWhichATeamIsSkilledResponse> {
   return makeRequest('get', `/skills/teams/${teamid}/courses`, {
      ...common,
      query: {
         query,
         order,
         offset,
         limit,
      },
   });
}
